import { DamageMissingTrimIcon } from '@motorway/mw-highway-code';

import type { Enquiry } from '@motorway/motorway-handshake-components/types';

import type { DamageItem } from '../../@types/DamageItem';

import styles from './Damage.module.scss';

type PrepItems = Enquiry['sellerPrep']['prepItems'];

export const Damage = ({ prepItems }: { prepItems: PrepItems | undefined }) => {
  const displayDamageItems = prepItems?.reduce<Record<string, DamageItem>>((acc, item) => {
    const key = item.fieldPath;
    if (!acc[key]) {
      acc[key] = { ...item, count: 1 };
    }
    else {
      acc[key].count += 1;
    }
    return acc;
  }, {});

  const result = Object.values(displayDamageItems ?? {});

  const hasDamage = Array.isArray(result) && result.length > 0
    ? result
        .filter((item): item is DamageItem => typeof item.sellerLabel === 'string' && !!item.sellerLabel)
        .map((item, index) => (
          <li key={`${item.sellerLabel}-${index}`}>
            <DamageMissingTrimIcon />
            {item.sellerLabel}
            {item.count > 1 && (
              <span className={styles.damageCount}>
                x
                {item.count}
              </span>
            )}
          </li>
        ))
    : <li>No declared damage</li>;

  return (
    <>
      <h3>Declared damage</h3>
      <p>This damage was declared before the live sale and factored into the price.</p>
      {
        Array.isArray(result)
          ? (
              <ul>
                {hasDamage}
              </ul>
            )
          : (
              <p>Something went wrong with fetching damage items</p>
            )
      }
    </>
  );
};
